<script>
    import R, {LOADER} from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import ColoredAcronym from "./ColoredAcronym.svelte";
    import {acronym} from "../../lib/lib";
    import ServiceColorName from "./ServiceColorName.svelte";

    export let serviceId = null;
    export let serviceType = null;
    // export let clientId = null;
    // export let projectId = null;
    export let service = null;
    export let labelOnTop = false;
    // export let excludeFromSelection = []; // service objects to exclude from selection
    export let placeholder = "εύρεση υπηρεσίας";

    let name = service ? service.name : '';
    let results = [];
    let listIndex = -1;
    let excludeIds = [];
    let timer;
    let showDropdown = false;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onKeydown = (event) => {
        if (results && results.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= results.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = results.length - 1;
                }
            } else if (event.key === 'Enter' && listIndex > -1) {
                event.preventDefault();
                selectResult(results[listIndex]);
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        }
    }

    const onKeyup = (event) => {
        if (!event.target.value && service) {
            service = null;
            serviceId = null;
            dispatch('change', null);
        }

        if (name !== event.target.value) {
            name = event.target.value;
            if (timer) {
                clearInterval(timer);
            }
            timer = setInterval(() => {
                clearInterval(timer);
                load();
            }, 500);
        }
    }

    const onFocusIn = () => {
        if (!service) {
            load();
        }
    }

    const onFocusOut = () => {
        if (service === null) {
            name = '';
        }
    }

    const selectResult = (item) => {
        name = item.name;
        serviceId = item.id;
        service = item;
        dispatch('change', item);
        closeDropdown();
    }

    const load = () => {
        const onSuccess = result => {
            results = [];
            result.map(item => {
                if (excludeIds.indexOf(item.id) < 0) {
                    results.push(item);
                }
            });
            console.log(results);
            openDropdown();
        }

        const onFailure = err => {
        };

        R.handle(R.service.index, {name: name, type: serviceType}, onSuccess, onFailure);
    }

    const openDropdown = () => {
        if (!showDropdown) {
            showDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        }
    }

    const closeDropdown = () => {
        if (showDropdown) {
            showDropdown = false;
            results = [];
            listIndex = -1;
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }


    // $: {
    //     if (excludeFromSelection) {
    //         if (excludeFromSelection.length != excludeIds.length) {
    //             excludeIds = excludeFromSelection.map(item => {
    //                 return item.id;
    //             });
    //         }
    //     } else {
    //         excludeIds = [];
    //     }
    // }
</script>

<div class="select-control" use:clickOutside on:click_outside="{ closeDropdown }">
    <div class="search form-control-container">
        <input type="text" class="form-control" id="searchProjectName" value="{ name }"
               on:keydown="{ onKeydown }"
               on:keyup="{ onKeyup }"
               on:focusin={ onFocusIn }
               on:focusout={ onFocusOut }
               autocomplete="off"
               {placeholder}>
        {#if service && service.ws_service}
            <div class="label" class:bottom={ !labelOnTop }>{ service.ws_service.name }</div>
        {/if}
    </div>
    {#if showDropdown}
        <div class="control-dropdown">
            <ul>
                {#if results.length}
                    {#each results as item, index}
                        <li class="dropdown-item" class:active="{ listIndex === index }"
                            on:click="{ () => selectResult(item) }">
                            <ServiceColorName service={item} />
<!--                            <ColoredAcronym acronym="{ acronym(item.ws_service.name) }" name="{ item.name }"-->
<!--                                            color="{ item.ws_service.color }"/>-->
                            <!--{ item.name }-->
                            <!--                            <div class="small text-gray">{ item.ws_service.name }</div>-->
                        </li>
                    {/each}
                {/if}
            </ul>
        </div>
    {/if}
</div>

<style>
    .select-control {
        position: relative;
    }

    .select-control .control-dropdown {
        position: absolute;
        width: max-content;
        min-width: 200px;
        background: var(--dropdown-background);
        box-shadow: var(--dropdown-box-shadow);
        z-index: 5000;
    }

    .control-dropdown ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .control-dropdown ul > li.input-item {
        padding: 15px;
    }

    .control-dropdown ul > li.dropdown-item {
        cursor: pointer;
        padding: 10px 10px;
    }

    .control-dropdown ul > li.dropdown-item:hover,
    .control-dropdown ul > li.dropdown-item.active {
        background: var(--dropdown-item-hover-background);
    }

    /*.control-dropdown ul > li.dropdown-button {*/
    /*    text-align: center;*/
    /*    background: var(--dropdown-button-background);*/
    /*    cursor: pointer;*/
    /*    padding: 10px 20px;*/
    /*}*/

    .control-dropdown ul > li.separator {
        border-top: var(--dropdown-separator);
    }
</style>